export const BASE_URL = 'https://admin.ldbconstruction.com'
// export const BASE_URL = 'https://admin.ldbconstruction.stageoptimal.co.za'
// export const BASE_URL = 'http://127.0.0.1:8000'